import { createSvgIcon } from "@mui/material/utils";

export default createSvgIcon(
  <path
    d="M19 19H5V17H19V19ZM10 14.42L6 10.42L7.41 9.01L10 11.59L16.59 5L18 6.42L10 14.42Z"
    xmlns="http://www.w3.org/2000/svg"
  />,
  "DownloadDone"
);
